import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Button, CircularProgress, TextField } from "@material-ui/core";
import formHandlerHOC, { isInvalidField } from '../../../../components/FormHandlerHOC';
import If from '../../../../components/If';
import ErrorMessage from '../../../../components/ErrorMessage';
import Fvt from '../../../../components/FieldValidationText';
import FieldInfo from '../../../../components/FieldInfo';
import _handleSubmit from '../submitEventHandler';

class PassEditor extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            showPassFieldInfo: false,
        };
    }

    render() {
        const {
            classes, requestInProgress, onSubmit,
            onFormChange, formState, resetForm, validateForm,
            getFormData, getFormStateSync, setFieldValue,
            isClearFormNeeded, isCurrentPasswordInvalid,
            generalError
        } = this.props;
        const { isValid, isPristine, password, newPassword, newPassword_confirmation } = formState;
        const { showPassFieldInfo } = this.state;

        if (isClearFormNeeded && isClearFormNeeded()) {
            setTimeout(resetForm);
        } else if (isCurrentPasswordInvalid && isCurrentPasswordInvalid()) {
            setTimeout(() => {
                setFieldValue('password', '');
                validateForm();
            });
        }
        return (<form action="#" className={classes.passEditor}
                      onSubmit={e => _handleSubmit(e, onSubmit, {
                          formState,
                          validateForm,
                          getFormData,
                          getFormStateSync
                      })}>
            <TextField name="password"
                       value={password.value}
                       onChange={onFormChange}
                       error={isInvalidField(password)}
                       label='Current Password' required fullWidth margin="normal"
                       type='password' autoComplete="current-password"/>
            <Fvt>{password.primaryMessage}</Fvt>

            <TextField name="newPassword"
                       value={newPassword.value}
                       onChange={onFormChange}
                       onFocus={() => this.setState({ showPassFieldInfo: true })}
                       onBlur={() => this.setState({ showPassFieldInfo: false })}
                       error={isInvalidField(newPassword)}
                       label='New Password' required fullWidth margin="normal"
                       type='password'/>
            <If as={FieldInfo} condition={showPassFieldInfo}>
                Should have more than 7 characters, at least one uppercase letter, number and
                special character (!$#@ etc)
            </If>
            <Fvt>{newPassword.primaryMessage}</Fvt>

            <TextField name="newPassword_confirmation"
                       value={newPassword_confirmation.value}
                       onChange={onFormChange}
                       error={isInvalidField(newPassword_confirmation)}
                       label='Confirm New Password' required fullWidth
                       margin="normal" type='password'/>
            <Fvt>{newPassword_confirmation.primaryMessage}</Fvt>

            <If as={ErrorMessage} condition={!!generalError}>
                {generalError}
            </If>

            <Button disabled={!isValid || isPristine || requestInProgress}
                    fullWidth
                    variant="contained"
                    color="secondary"
                    className="submitButton"
                    type='submit'>
                Change Password <If as={CircularProgress} condition={requestInProgress} size={20}/>
            </Button>
        </form>);
    }
}

PassEditor.propTypes = {
    requestInProgress: PropTypes.bool,
    generalError: PropTypes.string,
    onSubmit: PropTypes.func,
    isClearFormNeeded: PropTypes.func,
    isCurrentPasswordInvalid: PropTypes.func,
};

export default formHandlerHOC({
    rules: {
        password: 'required',
        newPassword: 'required|confirmed|min:8|contains_alpha_numeric|contains_special_characters',
        newPassword_confirmation: 'required',
    },
    validationMessages: {
        required: 'Required',
        min: 'The password must contain at least 8 characters',
        confirmed: 'The new password and the confirmation must match',
        contains_special_characters: 'The new password should contain at least one special character',
        contains_alpha_numeric: 'The new password should contain at least one letter and one number',
    }
})(PassEditor);
